// extracted by mini-css-extract-plugin
module.exports = {"center":"Loader_center__11Q6W","containerHeight":"Loader_containerHeight__ZwIlw"};